<div class="full-height custom-term-container">
  <div class="d-flex flex-row align-items-center full-width buttons">
    <div class="d-flex flex-g1 justify-content-start">
      <span class="title" *ngIf="isCreate">{{'campaigns.term.campaign_new_term' | translate}}</span>
      <span class="title" *ngIf="!isCreate">{{'campaigns.term.campaign_edit_term' | translate}}</span>
    </div>
    <div class="d-flex flex-g1 justify-content-end">
      <button class="button red" (click)="back()">{{'common.btn.abort' | translate}}</button>
      <button class="button green" *ngIf="isCreate" (click)="add(term)">{{'common.btn.add' | translate}}</button>
      <button class="button green" *ngIf="!isCreate" (click)="edit(term)">{{'common.btn.save' | translate}}</button>
    </div>
  </div>
  <div class="d-flex flex-row full-height full-width details">
    <div class="d-flex flex-column flex-g7">
      <div class="d-flex align-items-center title-header">
        <span>{{'campaigns.term.term_information' | translate}}</span>
      </div>
      <div class="field-container">
        <achoo-text-field label="{{'campaigns.term.headline' | translate}}"
                          [(model)]="term.summary"
                          placeholder="{{'campaigns.term.headline_placeholder' | translate}}"
                          name="headline"
                          class="input-field">
        </achoo-text-field>
      </div>
      <div class="field-container">
        <achoo-text-field label="{{'campaigns.term.contract_headline' | translate}}"
                          [(model)]="term.heading"
                          placeholder="{{'campaigns.term.contract_headline_placeholder' | translate}}"
                          name="contract_headline"
                          class="input-field">
        </achoo-text-field>
      </div>
      <div class="field-container">
        <achoo-textarea label="{{'campaigns.term.body_text' | translate}}"
                        class="input-field full-width"
                        [numberCol]="10"
                        placeholder="{{'campaigns.term.body_text_placeholder' | translate}}"
                        [(model)]="term.body"
                        name="body_text">
        </achoo-textarea>
      </div>
    </div>
    <div class="d-flex flex-g9">
      
    </div>
  </div>

</div>



// WEBPACK FOOTER //
// ./src/app/main/campaigns-add/campaign-custom-term-details/campaign-custom-term-details.component.html